/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseApiService from '../baseApi.service';

export default class AuditLogsService extends BaseApiService {
  readonly basePath: string = 'eventlogs/v1';
  constructor(props = null) {
    super(props);
  }

  exportAuditLogs = async (
    params: object,
    onDownloadProgress: (progressEvent: any) => void
  ) => {
    return await this.getProgress('exportCSV', params, {}, progressEvent =>
      onDownloadProgress(progressEvent)
    ).then(async res => res?.data);
  };
}
